<template>
  <div>
    <GmapMap ref="map"
      :center="mapPos"
        :zoom="12"
        style="width: 100%; height: 900px"
        :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: true,
          streetViewControl: false,
          rotateControl: true,
          fullscreenControl: true,
          disableDefaultUi: false
        }"
      >
      <GmapPolygon v-for="(mapItem, index) in items" :paths="mapItem.paths" :key="index"
        @click="polygonClick(mapItem)"
        :options="{
          strokeColor: mapItem.strokeColour,
          fillColor: mapItem.strokeColour,
        }">
      </GmapPolygon>
      <!-- <GmapMarker
        v-for="(pointOfInterest, i) in pointsOfInterest"
        :key="pointOfInterest.id"
        :title="$$t(pointOfInterest.pointOfInterestType)"
        :label="$$t(pointOfInterest.pointOfInterestType)"
        :position="pointOfInterest.location"
        @dragend="passthroughPointDragEnd"
        :clickable="true"
        :draggable="true"
        :options="{
          strokeColor: editMapItem.strokeColour,
        }"
        @dblclick="removePointOfInterest(pointOfInterest)"
        @click="toggleInfoWindow(pointOfInterest,i)"
      />
      <GmapInfoWindow
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false"
      >
        <v-textarea
          :label="$$t('description')"
          v-model="selectedPointOfInterest.description"
        ></v-textarea>
        <v-btn
          color="error"
          class="mr-2"
          @click="removePointOfInterest(selectedPointOfInterest)"
        >
          {{ $t('common.buttons.delete') }}
        </v-btn>
        <v-btn
          color="success"
          @click="savePointOfInterest(selectedPointOfInterest)"
          :loading="isSaving">
          {{ $t('common.buttons.save') }}
        </v-btn>
      </GmapInfoWindow> -->
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import { mapActions, mapState } from 'vuex';
import { mdiCrosshairsGps, mdiMagnify } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import org from '@codehq/aurora-app-core/src/mixins/org';
import location from '../mixins/location';

export default {
  mixins: [location, loading, org],
  data() {
    return {
      mdiCrosshairsGps,
      mdiMagnify,
      mapPos: { lat: -28, lng: 26 },
      items: [],
    };
  },
  computed: {
    ...mapState('mapItems', ['mapItems']),
    google: gmapApi,
  },
  methods: {
    ...mapActions('mapItems', ['LOAD_mapItems']),
    /** Method used parse server geography to google lantLng
     */
    parseMapItemPoint(point) {
      if (!point) {
        return undefined;
      }
      const coord = point?.geography?.wellKnownText?.replace('POINT ', '')
        .replace('(', '')
        .replace(')', '');
      const coordArr = coord.split(/[ ,]+/);
      const lat = parseFloat(coordArr[1]);
      const lng = parseFloat(coordArr[0]);
      this.$log.info(coordArr);
      // eslint-disable-next-line no-undef
      const latLng = new google.maps.LatLng(lat, lng);
      return latLng;
    },
    polygonClick(mapItem) {
      this.$emit('selected', mapItem);
    },
    async refresh() {
      await this.LOAD_mapItems();
      const map = await this.$refs.map.$mapPromise;
      const bounds = new this.google.maps.LatLngBounds();
      const items = this.mapItems.map((i) => {
        const result = { ...i };
        result.paths = [];
        let polygonText = result.points?.geography?.wellKnownText;
        polygonText = polygonText?.replace('POLYGON ', '')
          .replace('((', '')
          .replace('))', '');
        const coords = polygonText?.split(', ') ?? [];
        coords.forEach((coord) => {
        // eslint-disable-next-line space-in-parens
          const coordArr = coord.split(/[ ,]+/);
          const lat = parseFloat(coordArr[1]);
          const lng = parseFloat(coordArr[0]);
          // eslint-disable-next-line no-undef
          const latLng = new this.google.maps.LatLng(lat, lng);
          result.paths.push(latLng);
          bounds.extend(latLng);
        });
        return result;
      });
      this.items = items;
      map.fitBounds(bounds);
      map.panToBounds(bounds);
    },
  },
  async mounted() {
    await this.refresh();
  },
};
</script>
